// extracted by mini-css-extract-plugin
module.exports = {"btn":"QuickTool_btn__lkXX_","tooltip":"QuickTool_tooltip__PHhAO","popover":"QuickTool_popover__S9Dai"};